// extracted by mini-css-extract-plugin
module.exports = {"game":"game--31scc","game_cont":"game_cont--1Bg05"};